<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import tdTheme from './theme.json' // 引入默认主题
import '../map/fujian.js'

export default {
  name: 'echart',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '2.5rem'
    },
    options: {
      type: Object,
      default: ()=>({})
    }
  },
  data () {
    return {
      chart: null,
      startRadars: undefined,
      // 鼠标移上去，自动切换取消
      flag: true,
      charRadarCurrentIndex: 0
    }
  },
  watch: {
    options: {
      handler (options) {
        // 设置true清空echart缓存
        this.chart.setOption(options, true)
      },
      deep: true
    }
  },
  mounted () {
    this.$echarts.registerTheme('tdTheme', tdTheme); // 覆盖默认主题
    this.initChart();
  },
  beforeDestroy () {
    this.chart.dispose()
    this.chart = null
    clearInterval(this.startRadars)
  },
  methods: {
    initChart () {
      // 初始化echart
      this.chart = this.$echarts.init(this.$el, 'tdTheme')
      // console.log(this.options)
      this.chart.setOption(this.options, true)
      // this.bindAutoplay()
    },
    bindAutoplay() {
      const _this = this
      // 鼠标移动上去的时候的高亮动画
      _this.chart.on("mouseover", function(param) {
        _this.flag = false;
        clearInterval(_this.startRadars);
        console.log(param.dataIndex)
        _this.charRadarCurrentIndex = param.dataIndex
        //记录上一次选中值重新进入时取消高亮
        //取消之前高亮图形
        _this.chart.dispatchAction({
          type: "downplay",
          seriesIndex: 1,
          dataIndex: _this.charRadarCurrentIndex
        });

        //高亮当前图形
        _this.chart.dispatchAction({
          type: "highlight",
          seriesIndex: 1,
          dataIndex: _this.charRadarCurrentIndex
        });
        //显示tooltip
        _this.chart.dispatchAction({
          type: "showTip",
          seriesIndex: 1,
          dataIndex: _this.charRadarCurrentIndex
        });
      });

      //图标随窗口大小缩放
      window.addEventListener("resize", function() {
        _this.chart.resize();
      });

      //自动高亮显示
      var chartHover = function() {
        var dataLength = 7
        // 取消之前高亮的图形
        _this.chart.dispatchAction({
          type: "downplay",
          seriesIndex: 1,
          dataIndex: _this.charRadarCurrentIndex-1
        })
        _this.charRadarCurrentIndex = (_this.charRadarCurrentIndex + 1) % dataLength
        if(_this.charRadarCurrentIndex == 0) {
            // 取消所有高亮
            _this.chart.dispatchAction({
                type: "downplay",
                seriesIndex: 1
            });
            _this.chart.dispatchAction({
                type: 'hideTip',
                seriesIndex: 1
            })
        } else {
            // 高亮当前图形
            _this.chart.dispatchAction({
                type: "highlight",
                seriesIndex: 1,
                dataIndex: _this.charRadarCurrentIndex-1
            })
            _this.chart.dispatchAction({
                type: 'showTip',
                seriesIndex: 1,
                dataIndex: _this.charRadarCurrentIndex-1,
                position: 'right'
            })
        }
      };

      _this.startRadars = setInterval(chartHover, 4000);

      //鼠标移出之后，恢复自动高亮
      _this.chart.on("mouseout", function() {
        // 取消所有高亮
        _this.chart.dispatchAction({
            type: "downplay",
            seriesIndex: [0, 1]
        });
        if (!_this.flag) {
          _this.startRadars = setInterval(chartHover, 4000);
          _this.flag = true;
        }
      })
    }
  }
}
</script>

<style>
</style>
